export const actionTypes = {
  REQUEST_START: 'CONTACTS.TAX_AUTHORITY.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.TAX_AUTHORITY.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.TAX_AUTHORITY.REQUEST_FAILURE',
};

export function startRequest(taxCode) {
  return {
    type: actionTypes.REQUEST_START,
    payload: taxCode,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
